import {
  CLOUD_INFRA_PAIN_MINUTES,
  CLOUD_INFRA_PAIN_MINUTES_SUCCESS,
  CLOUD_INFRA_PAIN_MINUTES_ERROR,
  CLOUD_INFRA_PAIN_MINUTES_EMPTY,
} from '../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CloudInfraPainMinutes = (state = initialState, action) => {
  switch (action.type) {
    case CLOUD_INFRA_PAIN_MINUTES:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CLOUD_INFRA_PAIN_MINUTES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CLOUD_INFRA_PAIN_MINUTES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CLOUD_INFRA_PAIN_MINUTES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CloudInfraPainMinutes;
